var isBrowser = function() {
  return typeof window !== "undefined" && window.name !== "nodejs";
};
var JSX_SHELL_STREAM_END_MARK = "<!--<?- SHELL_STREAM_END ?>-->";
var ESCAPED_SHELL_STREAM_END_MARK = "&lt;!--&lt;?- SHELL_STREAM_END ?&gt;--&gt;";
export {
  ESCAPED_SHELL_STREAM_END_MARK,
  JSX_SHELL_STREAM_END_MARK,
  isBrowser
};
